/**
 * Critérios para abrir solicitação com prioridade Alta ou Urgência (#6179).
 *
 * Alta: impede alguém de trabalhar ou causa perda de dinheiro.
 * Urgência: um critério da Alta e mais um agravante.
 * O critério marcado vai para a descrição da solicitação, para quem atende ver o motivo.
 */

export interface CriterioPrioridade {
    id: string;
    texto: string;
}

export const CRITERIOS_ALTA: CriterioPrioridade[] = [
    { id: 'impede_trabalho', texto: 'Impede alguém de trabalhar' },
    { id: 'perda_dinheiro', texto: 'Causa perda de dinheiro' },
];

export const CRITERIOS_URGENCIA_EXTRA: CriterioPrioridade[] = [
    { id: 'muitos_clientes', texto: 'Afeta muitos clientes ao mesmo tempo' },
    { id: 'prazo_hoje', texto: 'Tem prazo (legal, do banco ou do cliente) vencendo hoje' },
    { id: 'sistema_parado', texto: 'O sistema parou para todos' },
];

export const exigeCriterio = (prioridade: string, ehSolicitacao: boolean): boolean =>
    ehSolicitacao && (prioridade === 'alta' || prioridade === 'urgencia');

/** Os critérios marcados bastam para a prioridade escolhida? */
export function criteriosAtendidos(prioridade: string, marcados: string[]): boolean {
    const temAlta = CRITERIOS_ALTA.some(c => marcados.includes(c.id));
    if (prioridade === 'alta') return temAlta;
    if (prioridade === 'urgencia') return temAlta && CRITERIOS_URGENCIA_EXTRA.some(c => marcados.includes(c.id));
    return true;
}

/** Linha que vai para o fim da descrição. Vazia quando a prioridade não exige critério. */
export function textoCriterios(prioridade: string, marcados: string[]): string {
    if (prioridade !== 'alta' && prioridade !== 'urgencia') return '';
    const validos = prioridade === 'alta' ? CRITERIOS_ALTA : [...CRITERIOS_ALTA, ...CRITERIOS_URGENCIA_EXTRA];
    const textos = validos.filter(c => marcados.includes(c.id)).map(c => c.texto.toLowerCase());
    if (textos.length === 0) return '';
    return `Prioridade ${prioridade === 'alta' ? 'Alta' : 'Urgência'}: ${textos.join('; ')}.`;
}
